<template>
  <Container>
    <SocialLinks class="mb-5" />

    <div class="container">
      <form method="post" class="info-box" role="form" @submit.prevent="submit">
        <SectionHeader title="Let's Connect" />
        <div class="row">
          <div class="col-lg-6">
            <TextBox
              label="Name"
              name="name"
              placeholder="Enter name"
              v-model="form.name"
              :disabled="form.processing"
              :error="form.errors.name"
            />
          </div>
          <div class="col-lg-6">
            <TextBox
              label="Email"
              name="email"
              placeholder="Enter email"
              v-model="form.email"
              :disabled="form.processing"
              :error="form.errors.email"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-lg-6">
            <TextBox
              label="Mobile number"
              name="mobile"
              placeholder="Enter mobile"
              v-model="form.mobile"
              :disabled="form.processing"
              :error="form.errors.mobile"
            />
          </div>
          <div class="col-lg-6">
            <TextBox
              label="Subject"
              name="subject"
              placeholder="Enter subject"
              v-model="form.subject"
              :disabled="form.processing"
              :error="form.errors.subject"
            />
          </div>
        </div>
        <TextBox
          type="textarea"
          label="Message"
          name="message"
          placeholder="Enter message"
          v-model="form.message"
          :disabled="form.processing"
          :error="form.errors.message"
        />
        <div class="mt-4 text-center">
          <button
            class="btn btn-primary w-50"
            type="submit"
            :disabled="form.processing"
          >
            <div
              class="spinner-border spinner-border-sm"
              role="status"
              v-if="form.processing"
            ></div>
            <span v-else>Submit</span>
          </button>
        </div>
      </form>
    </div>
  </Container>
</template>
<script>
export default {
  components: {
    SocialLinks: () =>
      import(
        /* webpackChunkName: "home-shared-social-links" */ "./shared/socialLinks"
      ),
  },
  props: {
    mapUrl: null,
  },
  data() {
    return {
      form: this.$inertia.form({
        name: "",
        email: "",
        mobile: "",
        subject: "",
        message: "",
      }),
    };
  },
  methods: {
    submit() {
      this.form.post(this.$route("home.contact.submit"), {
        preserveScroll: true,
        onSuccess: () => {
          this.form.reset();
          this.form.clearErrors();
        },
      });
    },
  },
  computed: {
    settings() {
      return this.$page.props.config.settings;
    },
  },
};
</script>
<style lang="scss" scoped>
.info-box {
  background: var(--card-color);
  box-shadow: var(--box-shadow);
  border-radius: var(--border-radius);
  padding: 2rem;
  margin-bottom: 1rem;
  width: 100%;
  &.contact-box {
    display: flex;
    gap: 0.8rem;
    padding: 1.8rem 2rem;
    i {
      font-size: 1.3rem;
      color: var(--primary-dark);
      border-radius: 50%;
      background: rgba(var(--primary-rgb), 0.1);
      height: 3.4rem;
      width: 3.4rem;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    h3 {
      margin-bottom: 0.8rem;
    }
    a {
      font-weight: bold;
    }
    .content {
      flex: 1;
    }
  }
}
</style>